import { Spin } from 'antd';
import React, { FC } from 'react';
import { useCurrentUserTenantPermissionsFilter } from 'src/common/permission-hooks';
import { PermissionsConstants } from 'src/common/types';
import { useIdentity } from 'src/core/services/authentication';
import LicenseRoleAssignmentsListPage from './license-role-assignment-list';
import RoleAssignmentsListPage from './role-assignment-list';

const permissions = [
  PermissionsConstants.ManageGlobalLicenses,
  PermissionsConstants.ManageRoleAssignments,
  PermissionsConstants.ManageOrganizationRoleAssignments,
];

const RoleAssignmentMainPage: FC = () => {
  const identity = useIdentity();
  const [userPermissionsSet, checkingPermissions] = useCurrentUserTenantPermissionsFilter(identity, permissions);

  const usingLicenseRoles =
    !checkingPermissions &&
    userPermissionsSet.has(PermissionsConstants.ManageGlobalLicenses) &&
    !userPermissionsSet.has(PermissionsConstants.ManageOrganizationRoleAssignments) &&
    !userPermissionsSet.has(PermissionsConstants.ManageRoleAssignments);

  return (
    <>
      <Spin spinning={checkingPermissions}>
        {!checkingPermissions && usingLicenseRoles && <LicenseRoleAssignmentsListPage />}
        {!checkingPermissions && !usingLicenseRoles && <RoleAssignmentsListPage />}
      </Spin>
    </>
  );
};

export default RoleAssignmentMainPage;
